export const closedPromotionStorageKey = 'drawerClosedPromotion';
